import {
  FeedbackSource,
  FeedbackStatus
} from "../../interfaces/endpoints/ICustomerFeedback";

export const SOURCE_LABELS: Record<FeedbackSource, string> = {
  [FeedbackSource.ReportLine]: "Report Line",
  [FeedbackSource.ResultsFeedback]: "Results Feedback",
  [FeedbackSource.NotifyNoResults]: "Notify No Results",
  [FeedbackSource.NotifyFewResults]: "Notify Few Results",
  [FeedbackSource.RealTimeReport]: "Real-Time Report"
};

export const SOURCE_BADGE_CLASSES: Record<FeedbackSource, string> = {
  [FeedbackSource.ReportLine]: "bg-red-100 text-red-700",
  [FeedbackSource.ResultsFeedback]: "bg-amber-100 text-amber-700",
  [FeedbackSource.NotifyNoResults]: "bg-blue-100 text-blue-700",
  [FeedbackSource.NotifyFewResults]: "bg-indigo-100 text-indigo-700",
  [FeedbackSource.RealTimeReport]: "bg-blue-100 text-blue"
};

export const STATUS_LABELS: Record<FeedbackStatus, string> = {
  [FeedbackStatus.New]: "New",
  [FeedbackStatus.Reviewed]: "Reviewed",
  [FeedbackStatus.Actioned]: "Actioned"
};

export const STATUS_BADGE_CLASSES: Record<FeedbackStatus, string> = {
  [FeedbackStatus.New]: "bg-orange-100 text-orange-700",
  [FeedbackStatus.Reviewed]: "bg-gray-100 text-gray-700",
  [FeedbackStatus.Actioned]: "bg-green-100 text-green-700"
};

export const SOURCE_OPTIONS: Array<{ value: FeedbackSource; label: string }> = [
  { value: FeedbackSource.ReportLine, label: SOURCE_LABELS[FeedbackSource.ReportLine] },
  {
    value: FeedbackSource.ResultsFeedback,
    label: SOURCE_LABELS[FeedbackSource.ResultsFeedback]
  },
  {
    value: FeedbackSource.NotifyNoResults,
    label: SOURCE_LABELS[FeedbackSource.NotifyNoResults]
  },
  {
    value: FeedbackSource.NotifyFewResults,
    label: SOURCE_LABELS[FeedbackSource.NotifyFewResults]
  },
  {
    value: FeedbackSource.RealTimeReport,
    label: SOURCE_LABELS[FeedbackSource.RealTimeReport]
  }
];

export const STATUS_OPTIONS: Array<{ value: FeedbackStatus; label: string }> = [
  { value: FeedbackStatus.New, label: STATUS_LABELS[FeedbackStatus.New] },
  { value: FeedbackStatus.Reviewed, label: STATUS_LABELS[FeedbackStatus.Reviewed] },
  { value: FeedbackStatus.Actioned, label: STATUS_LABELS[FeedbackStatus.Actioned] }
];
export const formatRouteName = (raw: string | null | undefined): string =>
  (raw ?? "").split(",")[0].trim();

export const REASON_LABELS: Record<string, string> = {
  wrong_schedule: "Wrong schedule",
  wrong_departure: "Wrong departure location",
  price_mismatch: "Price mismatch",
  bus_was_late: "Bus was late",
  bus_did_not_arrive: "Bus didn't arrive",
  wrong_info: "Wrong info on the schedule",
  other: "Other",
  departure_time: "No good departure time",
  few_results: "Too few options",
  wrong_route: "Wrong route or station",
  thumbs_up: "Positive rating",
  thumbs_down: "Negative rating"
};

export const formatReason = (raw: string | null | undefined): string => {
  if (!raw) return "";
  const mapped = REASON_LABELS[raw];
  if (mapped) return mapped;
  const sentence = raw.replace(/_+/g, " ").trim();
  return sentence.charAt(0).toUpperCase() + sentence.slice(1);
};
